<template>
  <card context="secondary" :title="'Sensor '+sensor.id" class="col-md-4">
    <div class="d-flex flex-row justify-content-between flex-wrap">
      <div class="badge badge-primary">{{$t("message.value")}} {{sensor.value}} {{unit}}</div>
      <div
        :class="getBadge(sensor.state)+' clickable'"
        :title="$t('state.msgs.'+sensor.state)"
        @click="showPopper($event)"
      >Status: {{$t('state.'+sensor.state)}}</div>
    </div>
    <div class="d-flex flex-row justify-content-around">
      <radial-gauge
        :value="sensor.value"
        :options="{height:200,width:200,maxValue:300,majorTicks: [0,60,120,180,240,300], minorTicks:10}"
      />
    </div>
  </card>
</template>

<script>
import { RadialGauge } from "../../utils/gauges/";
import { getBadge } from "../../sheriffUtils.js";
import Card from "../resources/Card";
export default {
  name: "MovementSensorView",
  props: {
    sensor: {
      required: true,
      type: Object
    },
    unit: {
      required: true
    }
  },
  methods: {
    showPopper(event) {
      this.$root.$emit("show-popper", event, this.sensor);
    },
    getBadge
  },
  components: {
    RadialGauge,
    Card
  }
};
</script>

<style>
</style>
